import React from 'react';
import {mapIni, map} from './map'
import { connect } from 'react-redux';
import { showMenu } from '../contextmenu/actions';
import { revGeoAddress } from '../reverseGeocoding/actions';

//import SearchContainer from '../search/container';

class MapComponent extends React.Component {

    componentDidMount() {

        mapIni();

    }
    contextMenu(e) {

        e.preventDefault();
      
    }
/*
                    <div style={{width: '300px', position: 'absolute', zIndex: '200', top: '6px', left: '40px'}}>
                    <SearchContainer />
                </div>
 */

    clickHandler(e) {

    this.props.clickHandler(e);
  }

    render() {

        return (
            <div id="map" style={{padding: "0px", height: window.innerHeight + 'px'}} onClick={this.clickHandler.bind(this)} onContextMenu={this.contextMenu.bind(this)}></div>
        );
    }
}

const mapStateToPropsRes = (state) => {

  return {};
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    contextMenuHandler: data => {

      var coord = map.getCoordinateFromPixel(data);

      dispatch(showMenu({pixel: data, coord: [parseFloat(coord[0].toFixed(2)), parseFloat(coord[1].toFixed(2))]}));
      dispatch(revGeoAddress(coord));
    },
    clickHandler: data => {
      dispatch(showMenu(null));
      
    }
  };
};

const MapContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(MapComponent);



export default MapContainer;



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/container.js